import React, {useState} from 'react';
import 'fontsource-roboto';
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import StepContent from '@material-ui/core/StepContent';

import StepTiles from './../Components/StepTiles';
import StepList from './../Components/StepList';
import StepOptions from './../Components/StepOptions';
import StepForm from './../Components/StepForm';
import StepIframe from './../Components/StepIframe';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(1, 0)
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  listItemDense: {
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  listItemIcon: {
    minWidth: theme.spacing(5)
  },
  listItemTextDense: {
    marginTop: '0px',
    marginBottom: '0px'
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  fabIcon: {
    marginRight: theme.spacing(1)
  },
  stepper: {
    padding: '24px 8px',
    '& .MuiStepConnector-line.MuiStepConnector-lineVertical': {
      minHeight: theme.spacing(1)
    }
  },
  stepButton: {
    justifyContent: 'start',
    padding: theme.spacing(0, 1),
    '& .MuiStepLabel-root.MuiStepLabel-vertical': {
      flexGrow: 1,
      textAlign: 'left'
    }
  }
}));

const todayDate = (new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60 * 1000))).toISOString().split('T')[0];

// tiles: se selecteaza doar o singura optiune din cele afisate si se trece automat la pasul urmator
// options: se bifeaza optiunile dorite din lista afisata. Trecerea la pasul urmator se face manual
// form: se completeaza campurile din formular. Trecerea la pasul urmator se face manual
// iframe: ceva genul PIAS. Trecerea la pasul urmator se face manual

// daca intrun pas exista doar o optiune disponibila, se va selecta in mod automat!!!
const defaultSteps = [
  /* Categoria serviciului */
  {
    name: 'serviceCategory',
    isDefault: true,
    type: 'tiles',
    title: 'Categorie serviciu',
    options: [
      {id: '1', label: 'Fise'             },
      {id: '2', label: 'Laborator'        },
      {id: '3', label: 'Consultatii'      },
      {id: '4', label: 'Cursuri de igiena'}
    ],
    xs: 12, sm: 6, md: 3,
    storeTo: 'idServiceCategory',
    isCompleted: false,
    nextStep: 'service'
  },
  /* Denumirea serviciului*/
  {
    name: 'service',
    type: 'tiles',
    title: 'Serviciu',
    options: [
      {id: '1', idServiceCategory: '1', label: 'Fisa auto'             , nextStep: 'serviceSheetDriverOptions'      },
      {id: '2', idServiceCategory: '1', label: 'Fisa paza'             , nextStep: 'serviceSheetSecurityOptions'    },
      {id: '3', idServiceCategory: '1', label: 'Fisa port-arma'        , nextStep: 'serviceSheetWeaponOptions'      },
      {id: '4', idServiceCategory: '1', label: 'Fisa SC'               , nextStep: 'serviceSheetTransportSafetyType'},
      {id: '5', idServiceCategory: '1', label: 'Fisa MM'               , nextStep: 'serviceSheetLaborMedicineUsage' },
      {id: '6', idServiceCategory: '2', label: 'Analize medicale'      , nextStep: 'medicalAnalisysInsurer'         },
      {id: '7', idServiceCategory: '3', label: 'Ecografie'             , nextStep: ''                               },
      {id: '8', idServiceCategory: '3', label: 'Obstetrica ginecologie', nextStep: ''                               },
      {id: '9', idServiceCategory: '4', label: 'Curs de igiena'        , nextStep: ''                               }
    ],
    xs: 12, sm: 6, md: 3,
    storeTo: 'idService',
    isCompleted: false
  },

  /* FISA AUTO */
  /* Ce presupune fisa auto */
  {
    name: 'serviceSheetDriverOptions',
    type: 'tiles',
    title: 'Tip fisa auto',
    options: [
      {id: '1', label: 'Doar aviz psihologic'     },
      {id: '2', label: 'Fisa fara aviz psihologic'},
      {id: '3', label: 'Fisa cu aviz psihologic'  }
    ],
    xs: 12, sm: 6, md: 4,
    storeTo: 'serviceSheetDriverOptions',
    isCompleted: false,
    nextStep: 'serviceSheetDriverUsage'
  },
  /* Pentru ce este necesara fisa auto */
  {
    name: 'serviceSheetDriverUsage',
    type: 'tiles',
    title: 'Fisa auto necesara pentru',
    options: [
      {id: '1', label: 'Obtinere'    },
      {id: '2', label: 'Preschimbare'},
      {id: '3', label: 'Redobandire' }
    ],
    xs: 12, sm: 4, md: 4,
    storeTo: 'usageReason',
    isCompleted: false,
    nextStep: 'serviceSheetDriverType'
  },
  /* Categoria de fisa auto */
  {
    name: 'serviceSheetDriverType',
    type: 'tiles',
    title: 'Categorie fisa auto',
    options: [
      {id: '1', label: 'Categoria I (amatori)'       },
      {id: '2', label: 'Categoria II (profesionisti)'},
      {id: '3', label: 'Categoria I si II'           }
    ],
    xs: 12, sm: 6, md: 6,
    storeTo: 'idSheetDriverType',
    isCompleted: false,
    nextStep: 'serviceSheetDriverCarCategories'
  },
  /* Categorii auto pentru care se doreste eliberarea fisei auto */
  {
    name: 'serviceSheetDriverCarCategories',
    type: 'options',
    title: 'Categorii auto selectate',
    options: [
      {id: '1' , idSheetDriverType: '1', label: 'AM' },
      {id: '2' , idSheetDriverType: '1', label: 'A1' },
      {id: '3' , idSheetDriverType: '1', label: 'A2' },
      {id: '4' , idSheetDriverType: '1', label: 'A'  },
      {id: '5' , idSheetDriverType: '1', label: 'B'  },
      {id: '6' , idSheetDriverType: '1', label: 'B1' },
      {id: '7' , idSheetDriverType: '1', label: 'BE' },
      {id: '8' , idSheetDriverType: '2', label: 'C'  },
      {id: '9' , idSheetDriverType: '2', label: 'C1' },
      {id: '10', idSheetDriverType: '2', label: 'C1E'},
      {id: '11', idSheetDriverType: '2', label: 'CE' },
      {id: '12', idSheetDriverType: '2', label: 'D'  },
      {id: '13', idSheetDriverType: '2', label: 'D1' },
      {id: '14', idSheetDriverType: '2', label: 'D1E'},
      {id: '15', idSheetDriverType: '2', label: 'DE' },
      {id: '16', idSheetDriverType: '2', label: 'Tr' },
      {id: '17', idSheetDriverType: '2', label: 'Tb' },
      {id: '18', idSheetDriverType: '2', label: 'Tv' },
      {id: '19', idSheetDriverType: '3', label: 'AM' },
      {id: '20', idSheetDriverType: '3', label: 'A1' },
      {id: '21', idSheetDriverType: '3', label: 'A2' },
      {id: '22', idSheetDriverType: '3', label: 'A'  },
      {id: '23', idSheetDriverType: '3', label: 'B'  },
      {id: '24', idSheetDriverType: '3', label: 'B1' },
      {id: '25', idSheetDriverType: '3', label: 'BE' },
      {id: '26', idSheetDriverType: '3', label: 'C'  },
      {id: '27', idSheetDriverType: '3', label: 'C1' },
      {id: '28', idSheetDriverType: '3', label: 'C1E'},
      {id: '29', idSheetDriverType: '3', label: 'CE' },
      {id: '30', idSheetDriverType: '3', label: 'D'  },
      {id: '31', idSheetDriverType: '3', label: 'D1' },
      {id: '32', idSheetDriverType: '3', label: 'D1E'},
      {id: '33', idSheetDriverType: '3', label: 'DE' },
      {id: '34', idSheetDriverType: '3', label: 'Tr' },
      {id: '35', idSheetDriverType: '3', label: 'Tb' },
      {id: '36', idSheetDriverType: '3', label: 'Tv' }
    ],
    isRequired: true,
    xs: 4, sm: 2, md: 1,
    storeTo: 'carCategories',
    isCompleted: false,
    nextStep: 'servicePriceCategory'
  },

  /* FISA PAZA */
  /* Ce presupune fisa paza */
  {
    name: 'serviceSheetSecurityOptions',
    type: 'tiles',
    title: 'Tip fisa paza',
    options: [
      {id: '1', label: 'Doar aviz psihologic'     },
      {id: '2', label: 'Fisa fara aviz psihologic'},
      {id: '3', label: 'Fisa cu aviz psihologic'  }
    ],
    xs: 12, sm: 6, md: 4,
    storeTo: 'serviceSheetSecurityOptions',
    isCompleted: false,
    nextStep: 'serviceSheetSecurityType'
  },
  /* Categoria de fisa paza */
  {
    name: 'serviceSheetSecurityType',
    type: 'tiles',
    title: 'Inarmat',
    options: [
      {id: '0', label: 'Nu'},
      {id: '1', label: 'Da'}
    ],
    xs: 6, sm: 6, md: 6,
    storeTo: 'serviceSheetSecurityType',
    isCompleted: false,
    nextStep: 'servicePriceCategory'
  },

  /* FISA PORT-ARMA */
  /* Ce presupune fisa port-arma */
  {
    name: 'serviceSheetWeaponOptions',
    type: 'tiles',
    title: 'Tip fisa port-arma',
    options: [
      {id: '1', label: 'Doar aviz psihologic'     , nextStep: 'servicePriceCategory'},
      {id: '2', label: 'Fisa fara aviz psihologic', nextStep: 'serviceSheetWeaponUsage'},
      {id: '3', label: 'Fisa cu aviz psihologic'  , nextStep: 'serviceSheetWeaponUsage'   }
    ],
    xs: 12, sm: 6, md: 4,
    storeTo: 'serviceSheetWeaponOptions',
    isCompleted: false
  },
  /* Pentru ce este necesara fisa port-arma */
  {
    name: 'serviceSheetWeaponUsage',
    type: 'tiles',
    title: 'Reinnoire fisa port-arma',
    options: [
      {id: '0', label: 'Nu'},
      {id: '1', label: 'Da'}
    ],
    xs: 6, sm: 6, md: 6,
    storeTo: 'usageReason',
    isCompleted: false,
    nextStep: 'serviceSheetWeaponType'
  },
  /* Categoria de fisa port-arma */
  {
    name: 'serviceSheetWeaponType',
    type: 'tiles',
    title: 'Tip arma',
    options: [
      {id: '1', label: 'Neletala' },
      {id: '2', label: 'Letala'   },
      {id: '3', label: 'Vanatoare'}
    ],
    xs: 4, sm: 4, md: 4,
    storeTo: 'idServiceSheetWeaponType',
    isCompleted: false,
    nextStep: 'servicePriceCategory'
  },

  /* FISA SIGURANTA CIRCULATIEI */
  /* Modul de transport pentru fisa SC */
  {
    name: 'serviceSheetTransportSafetyType',
    type: 'tiles',
    title: 'Mijloc de transport',
    options: [
      {id: '1', label: 'Rutier'    },
      {id: '2', label: 'Maritim'   },
      {id: '3', label: 'Feroviar'  },
      {id: '4', label: 'Fluvial'   },
      {id: '5', label: 'Aeronautic'}
    ],
    xs: 6, sm: 4, md: 2,
    storeTo: 'idServiceSheetTransportSafetyType',
    isCompleted: false,
    nextStep: 'serviceSheetTransportSafetyUsage'
  },
  /* Pentru ce este necesara fisa SC */
  {
    name: 'serviceSheetTransportSafetyUsage',
    type: 'tiles',
    title: 'Fisa SC necesara pentru',
    options: [
      {id: '1', label: 'Admitere in scoala'},
      {id: '2', label: 'Angajare'          },
      {id: '3', label: 'Control periodic'  },
      {id: '4', label: 'Reangajare'        },
      {id: '5', label: 'Schimbare functie' },
      {id: '6', label: 'Sesizare'          }
    ],
    xs: 12, sm: 6, md: 4,
    storeTo: 'usageReason',
    isCompleted: false,
    nextStep: 'serviceSheetTransportSafetyFunctions'
  },
  /* Functii pentru care se elibereaza fisa SC */
  {
    name: 'serviceSheetTransportSafetyFunctions',
    type: 'options',
    title: 'Functii selectate',
    options: [
      {id: '1', idServiceSheetTransportSafetyType: '1', label: 'Rutier 1'},
      {id: '2', idServiceSheetTransportSafetyType: '1', label: 'Rutier 2'},
      {id: '3', idServiceSheetTransportSafetyType: '1', label: 'Rutier 3'},
      {id: '4', idServiceSheetTransportSafetyType: '2', label: 'Maritim 1'},
      {id: '5', idServiceSheetTransportSafetyType: '2', label: 'Maritim 2'},
      {id: '6', idServiceSheetTransportSafetyType: '2', label: 'Maritim 3'},
      {id: '7', idServiceSheetTransportSafetyType: '3', label: 'Feroviar 1'},
      {id: '8', idServiceSheetTransportSafetyType: '3', label: 'Feroviar 2'},
      {id: '9', idServiceSheetTransportSafetyType: '3', label: 'Feroviar 3'},
      {id: '10', idServiceSheetTransportSafetyType: '4', label: 'Fluvial 1'},
      {id: '11', idServiceSheetTransportSafetyType: '4', label: 'Fluvial 2'},
      {id: '12', idServiceSheetTransportSafetyType: '4', label: 'Fluvial 3'},
      {id: '13', idServiceSheetTransportSafetyType: '5', label: 'Aeronautic 1'},
      {id: '14', idServiceSheetTransportSafetyType: '5', label: 'Aeronautic 2'},
      {id: '15', idServiceSheetTransportSafetyType: '5', label: 'Aeronautic 3'}
    ],
    isRequired: true,
    xs: 12, sm: 12, md: 12,
    storeTo: 'transportationFunctions',
    isCompleted: false,
    nextStep: 'serviceSheetTransportSafetyServices'
  },
  /* Ce servicii sunt necesare pentru fisa SC */
  {
    name: 'serviceSheetTransportSafetyServices',
    type: 'options',
    title: 'Fisa completa/incompleta',
    options: [
      {id: '1', label: 'Medicina interna'  },
      {id: '2', label: 'Chirurgie generala'},
      {id: '3', label: 'Oftalmologie'      },
      {id: '4', label: 'ORL'               },
      {id: '5', label: 'Neurologie'        },
      {id: '6', label: 'Psihiatrie'        },
      {id: '7', label: 'Analize medicale'  }
    ],
    isRequired: true,
    xs: 12, sm: 6, md: 4,
    storeTo: 'transportationConsultations',
    isCompleted: false,
    nextStep: 'serviceSheetTransportSafetyDetails'
  },
  /* Alte detalii legate de fisa SC */
  {
    name: 'serviceSheetTransportSafetyDetails',
    type: 'form',
    title: 'Detalii fisa SC',
    fields: {
      'workingYears' : {name: 'workingYears' , label: 'Vechime ani'                      , value: '', isRequired: true },
      'workingMonths': {name: 'workingMonths', label: 'Vechime luni'                     , value: '', isRequired: true },
      'unitName'     : {name: 'unitName'     , label: 'Unitate/scoala'                   , value: '', isRequired: true },
      'unitAddress'  : {name: 'unitAddress'  , label: 'Adresa unitate/scoala'            , value: '', isRequired: true },
      'memoSL'       : {name: 'memoSL'       , label: 'Memo analize medicale (SmartLabs)', value: '', isRequired: false}
    },
    storeTo: 'transportationDetails',
    isCompleted: false,
    nextStep: 'servicePriceCategory'
  },

  /* FISA MM */
  /* Selectare beneficiar daca este cazul */
  /* Pentru ce este necesara fisa MM */
  {
    name: 'serviceSheetLaborMedicineUsage',
    type: 'tiles',
    title: 'Fisa MM necesara pentru',
    options: [
      {id: '1', label: 'Examen medical la angajare'},
      {id: '2', label: 'Examen medical periodic'   }
    ],
    xs: 12, sm: 6, md: 4,
    storeTo: 'usageReason',
    isCompleted: false,
    nextStep: 'serviceSheetLaborPartner'
  },
  {
    name: 'serviceSheetLaborPartner',
    type: 'tiles',
    title: 'Conform contractului incheiat cu',
    options: [
      {id: '0', label: 'Nu este cazul'    , nextStep: 'serviceSheetLaborMedicine'    , isDefault: true},
      {id: '1', label: 'SC VARD SA Tulcea', nextStep: 'serviceSheetLaborServicePacks'},
      {id: '2', label: 'Primaria Tulcea'  , nextStep: 'serviceSheetLaborServicePacks'}
    ],
    xs: 12, sm: 6, md: 4,
    storeTo: 'idPartner',
    isCompleted: false
  },
  /* Riscuri profesionale */
  {
    name: 'serviceSheetLaborMedicine',
    type: 'options',
    title: 'Riscuri profesionale',
    options: [
      {id: '1' , label: 'Muncă la înălţime'                                                                                                            },
      {id: '2' , label: 'Muncă în reţelele de foarte înaltă, înaltă, medie şi joasă tensiune, aflate sau nu sub tensiune'                              },
      {id: '3' , label: 'Presiuni locale prelungite la nivelul părţilor moi şi al osului sau la nivelul formaţiunilor nervoase'                        },
      {id: '4' , label: 'Suprasolicitarea analizatorului vizual'                                                                                       },
      {id: '5' , label: 'Suprasolicitarea aparatului locomotor'                                                                                        },
      {id: '6' , label: 'Sectorul alimentar'                                                                                                           },
      {id: '7' , label: 'Sectorul zootehnic'                                                                                                           },
      {id: '8' , label: 'Industria farmaceutică'                                                                                                       },
      {id: '9' , label: 'Instalaţii centrale de aprovizionare cu apă potabilă şi alte unităţi de interes public'                                       },
      {id: '10', label: 'Personal din unităţile de coafură, frizerie, masaj, cosmetică (manichiură şi pedichiură)'                                     },
      {id: '11', label: 'Personal care asigură întreţinerea curăţeniei în unităţile de cazare publică şi colectivă'                                    },
      {id: '12', label: 'Personalul de la băi, spălătorii publice şi piscine'                                                                          },
      {id: '13', label: 'Personalul din sectorul de salubritate şi ecarisaj'                                                                           },
      {id: '14', label: 'Personalul sanitar elementar, personalul de îngrijire, personalul care îngrijeşte persoana cu handicap şi asistentul maternal'},
      {id: '15', label: 'Personal sanitar superior şi mediu'                                                                                           },
      {id: '16', label: 'Personal didactic din instituţii de învăţământ'                                                                               },
      {id: '17', label: 'Personal cu funcţie de decizie'                                                                                               },
      {id: '18', label: 'Personal care în cadrul activităţii profesionale conduce utilaje, vehicule de transport intrauzinal şi/sau maşina instituţiei'},
      {id: '19', label: 'Personal care lucrează în condiţii de izolare'                                                                                },
      {id: '20', label: 'Personal din străinătate care va lucra în România'                                                                            },
      {id: '21', label: 'Personal care lucrează în tura de noapte'                                                                                     },
      {id: '22', label: 'Agent de pază'                                                                                                                },
      {id: '23', label: 'Personal care lucrează ca pompier salvator intrauzinal, salvamar, salvamontist, alte categorii de salvatori'                  },
      {id: '24', label: 'Personal care lucrează cu substanţe toxice nominalizate în Legea nr. 360/2003'                                                }
    ],
    xs: 12, sm: 12, md: 12,
    storeTo: 'serviceSheetLaborMedicineRisks',
    isCompleted: false,
    nextStep: 'medicalAnalisysClientServicePacks'
  },
  /* Selectare pachete si servicii din cadrul contractului incheiat cu beneficarul */
  {
    name: 'serviceSheetLaborServicePacks',
    type: 'options',
    title: 'Pachete si servicii negociate',
    options: [
      {id: '1' , idPartner: '1', label: 'Personal TESA'                         },
      {id: '2' , idPartner: '1', label: 'Personal TESA + sofer'                 },
      {id: '3' , idPartner: '1', label: 'Personal TESA + tura de noapte'        },
      {id: '4' , idPartner: '1', label: 'Personal TESA + sofer + tura de noapte'},
      {id: '5' , idPartner: '1', label: 'Sofer + tura de noapte'                },
      {id: '6' , idPartner: '1', label: 'Tura de noapte'                        },
      {id: '7' , idPartner: '1', label: 'Lucru la inaltime'                     },
      {id: '8' , idPartner: '1', label: 'Lucru la inaltime + tura de noapte'    },
      {id: '9' , idPartner: '2', label: 'Examen clinic general'                 },
      {id: '10', idPartner: '2', label: 'ORL'                                   },
      {id: '11', idPartner: '2', label: 'Examen psihologic'                     }
    ],
    isRequired: true,
    xs: 12, sm: 12, md: 6,
    storeTo: 'serviceSheetLaborServicePacks',
    isCompleted: false,
    nextStep: 'serviceSheetLaborDoctorChoices'
  },
  /* Selectare pachete si servicii din cadrul contractului incheiat cu beneficarul */
  {
    name: 'serviceSheetLaborDoctorChoices',
    type: 'options',
    title: 'Examinari suplimentare conform riscurilor selectate recomandate de medicul de medicina muncii',
    options: [
      {id: '1' , category: 'Analize de laborator'   , label: 'Ac anti HCV'              },
      {id: '2' , category: 'Analize de laborator'   , label: 'Ac anti HIV 1,2'          },
      {id: '3' , category: 'Analize de laborator'   , label: 'Ag HBs'                   },
      {id: '4' , category: 'Analize de laborator'   , label: 'Ac anti HBs'              },
      {id: '5' , category: 'Analize de laborator'   , label: 'Examen coprobacteriologic'},
      {id: '6' , category: 'Analize de laborator'   , label: 'Examen coproparazitologic'},
      {id: '7' , category: 'Analize de laborator'   , label: 'Glicemie'                 },
      {id: '8' , category: 'Examene de specialitate', label: 'Examen clinic general'    },
      {id: '9' , category: 'Examene de specialitate', label: 'Examen psihiatric'        },
      {id: '10', category: 'Examene de specialitate', label: 'Examen psihologic'        },
      {id: '11', category: 'Examene de specialitate', label: 'Examen medicina interna'  },
      {id: '12', category: 'Examene de specialitate', label: 'Examen neurologic'        },
      {id: '13', category: 'Examene de specialitate', label: 'Examen oftalmologic'      },
      {id: '14', category: 'Examene de specialitate', label: 'Examen ORL'               },
      {id: '15', category: 'Examene de specialitate', label: 'Examen pneumologic'       }
    ],
    groupBy: 'category',
    xs: 12, sm: 6, md: 4,
    storeTo: 'serviceSheetLaborDoctorChoices',
    isCompleted: false,
    nextStep: 'medicalAnalisysClientServicePacks'
  },

  /* ANALIZE MEDICALE */
  /* Casa de asigurari */
  {
    name: 'medicalAnalisysInsurer',
    type: 'tiles',
    title: 'Casa de asigurari',
    options: [
      {id: '0', label: 'Nici o casa de asigurari', nextStep: 'medicalAnalisysClientServicePacks'},
      {id: '1', label: 'CAS Tulcea'              , nextStep: 'medicalAnalisysSendDetails'       },
      {id: '2', label: 'CASAOPSNAJ'              , nextStep: 'medicalAnalisysSendDetails'       }
    ],
    xs: 12, sm: 6, md: 4,
    storeTo: 'idInsuranceCompanySL',
    isCompleted: false
  },
  /* Detalii bilet de trimitere */
  {
    name: 'medicalAnalisysSendDetails',
    type: 'form',
    title: 'Detalii bilet de trimitere',
    fields: {
      'ticketSerial': {name: 'ticketSerial', type: 'text', label: 'Serie BT' , value: ''       , isRequired: true },
      'ticketNumber': {name: 'ticketNumber', type: 'text', label: 'Numar BT' , value: ''       , isRequired: true },
      'ticketDate'  : {name: 'ticketDate'  , type: 'date', label: 'Data BT'  , value: todayDate, isRequired: true , InputProps: {inputProps: {max: todayDate}}},
      'ticketBy'    : {name: 'ticketBy'    , type: 'text', label: 'Trimis de', value: ''       , isRequired: true }
    },
    storeTo: 'sendingTicketDetails',
    isCompleted: false,
    nextStep: 'medicalAnalisysInsuredServices'
  },
  /* Servicii de laborator care sunt decontate trecute pe bilet */
  {
    name: 'medicalAnalisysInsuredServices',
    type: 'options',
    title: 'Analize decontate',
    options: [
      {id: '1', label: 'Hemoleucograma completa'},
      {id: '2', label: 'VSH'                    },
      {id: '3', label: 'Glicemie'               }
    ],
    isRequired: true,
    xs: 12, sm: 12, md: 12,
    storeTo: 'servicesPaidByCnasSL',
    isCompleted: false,
    nextStep: 'medicalAnalisysClientServicePacks'
  },
  /* Pachete de servicii de laborator platite de client */
  {
    name: 'medicalAnalisysClientServicePacks',
    type: 'options',
    title: 'Pachete de analize platite de client',
    options: [
      {id: '1', label: 'Pachet 14 analize'},
      {id: '2', label: 'Preventie cancer' },
      {id: '3', label: 'Pachet gravide'   }
    ],
    xs: 12, sm: 12, md: 12,
    storeTo: 'servicePacksPaidByPatientSL',
    isCompleted: false,
    nextStep: 'medicalAnalisysClientServices'
  },
  /* Servicii de laborator platite de client */
  {
    name: 'medicalAnalisysClientServices',
    type: 'options',
    title: 'Analize platite de client',
    options: [
      {id: '3', label: 'Glicemie'            },
      {id: '4', label: 'Marker tumoral X74-s'},
      {id: '5', label: 'Gonococie'           }
    ],
    xs: 12, sm: 12, md: 12,
    storeTo: 'servicesPaidByPatientSL',
    isCompleted: false,
    nextStep: 'servicePriceCategory'
  },

  /* Categoria de pret pentru serviciul selectat */
  {
    name: 'servicePriceCategory',
    type: 'tiles',
    title: 'Categorie de pret',
    options: [
      {id: '1' , idService: '1', label: 'Pret de lista'   },
      {id: '2' , idService: '1', label: 'Autotur'         },
      {id: '3' , idService: '1', label: 'Valmar'          },
      {id: '4' , idService: '2', label: 'Pret de lista'   },
      {id: '5' , idService: '3', label: 'Pret de lista'   },
      {id: '6' , idService: '4', label: 'Pret de lista'   },
      {id: '7' , idService: '4', label: 'Ambulanta Tulcea'},
      {id: '8' , idService: '5', label: 'Pret de lista'   },
      {id: '9' , idService: '6', label: 'Pret de lista'   },
      {id: '10', idService: '6', label: 'Decontate'       },
      {id: '11', idService: '6', label: 'Pret special'    },
      {id: '12', idService: '7', label: 'Pret de lista'   },
      {id: '13', idService: '8', label: 'Pret de lista'   },
      {id: '14', idService: '9', label: 'Pret de lista'   }
    ],
    xs: 12, sm: 6, md: 4,
    storeTo: 'idServiceCategoryPrice',
    isCompleted: false,
    nextStep: 'personSearch'
  },

  /* MANAGEMENT CLIENT */
  /* Criterii de cautare client */
  {
    name: 'personSearch',
    type: 'form',
    title: 'Cautare persoana',
    fields: {
      'name': {name: 'name', type: 'text', label: 'Nume si prenume', value: 'stoian', isRequired: false},
      'cnp' : {name: 'cnp' , type: 'text', label: 'CNP'            , value: ''      , isRequired: false}
    },
    storeTo: 'searchPerson',
    isCompleted: false,
    nextStep: 'personSelect'
  },
  /* Rezultate cautare pacient */
  {
    name: 'personSelect',
    type: 'list',
    title: 'Rezultate cautare persoana',
    source: {
      type: 'ajax',
      op: 'getPersons',
      params: 'searchPerson'
    },
    options: [
      {id: '1', name: 'Stoian Iulian', cnp: '1800222360039', county: 'Tulcea', city: 'Cataloi', address: 'Str. Molidului nr. 23'},
      {id: '2', name: 'Stoian Elena' , cnp: '2910328360027', county: 'Tulcea', city: 'Cataloi', address: 'Str. Molidului nr. 23'}
    ],
    optionsMap: (option => {
      return {
        id: option.id,
        label: `${option.name} (${option.cnp})`,
        helper: `${option.address}, ${option.city} jud. ${option.county}`
      };
    }), // default (option => option.label) sau (option => {return {id: option.id, label: option.label, helper: ''}})
    xs: 12, sm: 6, md: 4,
    storeTo: 'idPerson',
    isCompleted: false,
    nextStep: 'personCheckInsuranceStatus'
  },
  /* Verificarea calitatii de asigurat prin PIAS */
  {
    name: 'personCheckInsuranceStatus',
    type: 'iframe',
    title: 'Verificare calitate asigurat (PIAS)',
    options: {
      url: 'http://siui.casan.ro:82/Asigurati/',
      width: '650px',
      height: '570px'
    },
    buttons: [
      {label: 'Neasigurat', value: '0', variant: 'outlined', color: 'secondary'},
      {label: 'Asigurat', value: '1', variant: 'contained', color: 'primary'}
    ],
    storeTo: 'isPatientInsured',
    isCompleted: false,
    nextStep: 'personDetails'
  },
  /* Actualizare detalii client */
  {
    name: 'personDetails',
    type: 'form',
    title: 'Actualizare date persoana',
    fields: {
      'name'    : {name: 'name'    , type: 'text', label: 'Nume si prenume', value: '', isRequired: true },
      'cnp'     : {name: 'cnp'     , type: 'text', label: 'CNP'            , value: '', isRequired: true },
      'phone'   : {name: 'phone'   , type: 'text', label: 'Telefon'        , value: '', isRequired: true },
      'email'   : {name: 'email'   , type: 'text', label: 'Email'          , value: '', isRequired: false},
      'county'  : {name: 'county'  , type: 'text', label: 'Judet'          , value: '', isRequired: true },
      'locality': {name: 'locality', type: 'text', label: 'Localitate'     , value: '', isRequired: true },
      'address' : {name: 'address' , type: 'text', label: 'Adresa'         , value: '', isRequired: true }
    },
    storeTo: 'person',
    isCompleted: false,
    nextStep: 'suggestedServices'
  },

  /* Alte servicii sugerate pentru clientul curent in functie de istoricul acestuia */
  {
    name: 'suggestedServices',
    type: 'options',
    title: 'Servicii sugerate',
    options: [
      {id: '1', label: 'Tromboglucobiloza'},
      {id: '2', label: 'Glicotriconina'   }
    ],
    xs: 12, sm: 12, md: 12,
    storeTo: 'suggestedServices',
    isCompleted: false,
    nextStep: 'servicePrices'
  },

  /* Ajustarea finala a preturilor: discount procentual per total sau per serviciu, gratuitati */
  {
    name: 'servicePrices',
    type: 'form',
    title: 'Facilitati financiare',
    fields: {},
    storeTo: 'prices',
    isCompleted: false,
    nextStep: 'paymentType'
  },

  /* Modalitate de plata */
  {
    name: 'paymentType',
    type: 'tiles',
    title: 'Modalitate de plata',
    options: [
      {id: '1', label: 'Programare'             , nextStep: 'scheduleDetails'},
      {id: '2', label: 'Se incaseaza mai tarziu', nextStep: 'lastStep'},
      {id: '3', label: 'Prepay'                 , nextStep: 'lastStep'},
      {id: '4', label: 'Bon fiscal'             , nextStep: 'paymentMethod'},
      {id: '5', label: 'Factura fiscala'        , nextStep: 'invoiceDownload'},
      {id: '6', label: 'Facturare la termen'    , nextStep: 'invoiceOnTime'}
    ],
    storeTo: 'paymentType',
    isCompleted: false
  },
  /* Detalii programare */
  {
    name: 'scheduleDetails',
    type: 'form',
    title: 'Detalii programare',
    fields: {},
    storeTo: 'scheduleDetails',
    isCompleted: false,
    nextStep: 'lastStep'
  },
  /* Modalitate de plata */
  {
    name: 'paymentMethod',
    type: 'tiles',
    title: 'Tip incasare',
    options: [
      {id: '1', label: 'Plata cash' , nextStep: 'invoiceOptions'},
      {id: '2', label: 'Plata card' , nextStep: 'invoiceOptions'},
      {id: '3', label: 'Plata mixta', nextStep: 'paymentDetails'}
    ],
    storeTo: 'idPaymentMethod',
    isCompleted: false,
  },
  /* Detalii plata mixta */
  {
    name: 'paymentDetails',
    type: 'form',
    title: 'Detalii plata mixta',
    fields: {
      'valueCash': {name: 'valueCash', type: 'text', label: 'Valoare cash', value: '0.00', isRequired: true },
      'valueCard': {name: 'valueCard', type: 'text', label: 'Valoare card', value: '0.00', isRequired: true }
    },
    storeTo: 'paymentDetails',
    isCompleted: false,
    nextStep: 'invoiceOptions'
  },
  /* Generare factura */
  {
    name: 'invoiceOptions',
    type: 'tiles',
    title: 'Factura',
    options: [
      {id: '0', label: 'Nu', nextStep: 'lastStep'},
      {id: '1', label: 'Da', nextStep: 'invoiceDownload'}
    ],
    storeTo: 'isInvoice',
    isCompleted: false
  },
  /* Descarcare factura */
  {
    name: 'invoiceDownload',
    type: 'form',
    title: 'Descarcare factura fiscala',
    fields: {},
    storeTo: '__dummy',
    isCompleted: false,
    nextStep: 'lastStep'
  },
  /* Marcare ca facturat la termen */
  {
    name: 'invoiceOnTime',
    type: 'tiles',
    title: 'Facturare la termen',
    options: [
      {id: '1', label: 'SC Hevaziune SRL'      },
      {id: '2', label: 'SC Ambulanta Tulcea SA'},
      {id: '3', label: 'SC Tremag SA'          }
    ],
    xs: 12, sm: 6, md: 4,
    storeTo: 'idPartner',
    isCompleted: false,
    nextStep: 'lastStep'
  },

  /* Informare utilizator ca fluxul cu clientul a luat sfarsit */
  {
    name: 'lastStep',
    type: 'message',
    title: 'Succes!!!',
    options: [],
    storeTo: '__dummy',
    isCompleted: false,
    nextStep: null
  }
];

export default function Test(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  // const isMountedRef = useIsMountedRef();

  const [data, setData] = useState({});
  const [steps, setSteps] = useState(defaultSteps.filter(step => step.isDefault));
  const [activeStep, setActiveStep] = useState(0);

  const handleListOptionsChange = (stepName, options) => {
    let tmpData = data;
    for (let index = 0; index < tmpData.length; index++) {
      if (tmpData[index].name === stepName) {
        tmpData[index].options = options;
        setData(tmpData);
        break;
      }
    }
  };

  const handleStepChanged = e =>{
    const value = Boolean(~['tiles', 'list'].indexOf(e.step.type)) ? e.value.id : e.value;

    let tmpData = data;
    let tmpSteps = steps;

    tmpSteps[activeStep].isCompleted = true;
    tmpSteps[activeStep].value = e.value;

    const nextStep = defaultSteps.filter(step => step.name === (e.value.nextStep ? e.value.nextStep : e.step.nextStep))[0];
    if (tmpSteps.length === activeStep + 1) {
      tmpSteps.push(nextStep);
    } else if (tmpSteps[activeStep + 1].name !== nextStep.name) {
      for (let index = activeStep + 1; index < tmpSteps.length; index++)
        tmpSteps[index].storeTo && delete(tmpData[tmpSteps[index].storeTo]);
      tmpSteps = tmpSteps.slice(0, activeStep + 1);
      tmpSteps.push(nextStep);
    }

    setData({...tmpData, [e.step.storeTo]: value});
    setSteps(tmpSteps);
    setActiveStep(activeStep + 1);
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Test stepper</Typography>
      <Typography variant='subtitle2'>Sistem unic integrat de management predictiv al nevoilor de servicii din sistemul de sanatate privat.</Typography>
      <Divider className={classes.divider} />

      <Box>
        <Typography variant='h5' color='secondary' align='center'>Ce cauti aici? Vrei sa te zic lu' nenea Iulian?</Typography>
        <Stepper activeStep={activeStep} orientation='vertical' className={classes.stepper}>
          {steps.map((step, index) => (
            <Step key={index}>
              <StepButton className={classes.stepButton}
                completed={step.isCompleted}
                onClick={() => setActiveStep(index)}
              >
                {step.title}
                {step.value && step.type === 'tiles' &&
                  <Typography color='primary' display='inline' style={{fontWeight: 'bold'}}>
                    {`: ${step.value.label}`}
                  </Typography>
                }
                {step.value && step.type === 'list' &&
                  <Typography color='primary' display='inline' style={{fontWeight: 'bold'}}>
                    {`: ${step.value.label}`}
                  </Typography>
                }
                {step.value && step.type === 'options' &&
                  <Typography color='primary' display='inline' style={{fontWeight: 'bold'}}>
                    {': '}
                    {step.options.filter(option => !!~step.value.indexOf(option.id)).map(option => option.label).join(', ')}
                  </Typography>
                }
                {/* {step.value && step.type === 'form' &&
                  <Typography color='primary' display='inline' style={{fontWeight: 'bold'}}> Completat</Typography>
                }
                {step.value && step.type === 'iframe' &&
                  <Typography color='primary' display='inline' style={{fontWeight: 'bold'}}> Completat</Typography>
                } */}

                {step.value && step.value.helper &&
                  <Typography color='textSecondary' align='left' style={{fontWeight: 'bold'}}>{step.value.helper}</Typography>
                }
              </StepButton>
              <StepContent>
                {/*
                // tiles: se selecteaza doar o singura optiune din cele afisate si se trece automat la pasul urmator
                // options: se bifeaza optiunile dorite din lista afisata. Trecerea la pasul urmator se face manual
                // form: se completeaza campurile din formular. Trecerea la pasul urmator se face manual
                // iframe: ceva genul PIAS. Trecerea la pasul urmator se face manual
                // daca intrun pas exista doar o optiune disponibila, se va selecta in mod automat!!!
                */}
                {
                  {
                    'tiles'  :  <StepTiles data={data} step={step}
                                  onChange={value => handleStepChanged({step: step, value: value})}
                                />,
                    'list'   :  <StepList data={data} step={step} ajax={ajax}
                                  sourceType={step.source && step.source.type ? step.source.type : 'array'}
                                  sourceOp={step.source && step.source.op ? step.source.op : null}
                                  sourceParams={step.source && step.source.params && data[step.source.params] ? data[step.source.params] : null}
                                  onOptionsChange={handleListOptionsChange}
                                  onChange={value => handleStepChanged({step: step, value: value})}
                                />,
                    'options':  <StepOptions data={data} step={step}
                                  onChange={value => handleStepChanged({step: step, value: value})}
                                />,
                    'form'   :  <StepForm data={data} step={step}
                                  onChange={value => handleStepChanged({step: step, value: value})}
                                />,
                    'iframe' :  <StepIframe step={step}
                                  onChange={value => handleStepChanged({step: step, value: value})}
                                />
                  }[step.type] || <Typography component='span' color='secondary'>Step type '{step.type}' is not handled.</Typography>
                }
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Box>

      {defaultSteps.map(step =>
        <Box key={step.name}>
          {step.storeTo === '' &&
            <Typography>Pasul {step.title} nu are variabila definita</Typography>
          }
          {step.type === 'tiles' && (!step.nextStep || step.nextStep === '') && step.options.filter(option => !option.nextStep).length === step.options.length &&
            <Typography>Pasul {step.title} nu are definit pasul urmator</Typography>
          }
          {step.type === 'tiles' && !step.nextStep && step.options.filter(option => !option.nextStep || option.nextStep === '').length > 0 && step.options.filter(option => !option.nextStep || option.nextStep === '').map(option =>
            <Typography key={JSON.stringify(option)}>Pasul {step.title} nu are definit pasul urmator pentru varianta: {option.label}</Typography>
          )}
        </Box>
      )}
    </Container>
  );
}